<script setup lang="ts">
import { LayerLegend } from '~/types/map'
import MapLegend from '~/components/map/MapLegend.vue'

defineProps<{ type: 'ui' | 'export' }>()

const { legends } = inject<{
  registerLegend: (legend: LayerLegend) => void
  legends: Ref<LayerLegend[]>
}>('layerLegends')

// const legends = computed(() => layerLegends?.legends.value || []);
watch(
  () => legends,
  () => {
    console.log('legends updated', legends.value)
    console.log(legends.value)
  }
)
</script>
<template>
  <div
    v-if="legends.length > 0"
    :id="type === 'ui' ? 'map-legends' : 'export-map-legends'"
    class="wrapper"
    :class="{ 'not-visible': type === 'export' }"
  >
    <MapLegend v-for="legend in legends" :key="legend.identifier" :legend="legend" />
  </div>
</template>
<style scoped>
/* .not-visible {
  background-color: red;
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  left: 0;
  z-index: 1;
} */
</style>
